import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedRow: null,
  formData: {
    brand_id: '',
    brand_name: '',
  },  // Menyimpan data yang diambil
  dataList: [],  // Menyimpan list data untuk persistence
  totalData: 0,  // Menyimpan total count untuk persistence
  loading: false,  // Menyimpan status loading
  error: null,  // Menyimpan pesan error jika ada
  loadingMessage: '',
  activeTab: 0,  // Menyimpan tab yang aktif (0 untuk List, 1 untuk Data)
};

const mst07brandSlice = createSlice({
  name: 'mst07brand',  // Nama slice yang sesuai
  initialState,
  reducers: {
    setSelectedRow: (state, action) => {
      state.selectedRow = action.payload;
    },
    setFormData: (state, action) => {
      state.formData = action.payload;
    },
    clearFormData: (state) => {
      state.formData = initialState.formData;  // Mengatur ulang formData ke nilai awal
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setErrorMsg: (state, action) => {
      state.error = action.payload;
    },
    setLoadingMessage: (state, action) => {
      state.loadingMessage = action.payload;
    },
    fetchDetailSuccess: (state, action) => {
      state.formData = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchDetailFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchDetailError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    updateFormData: (state, action) => {
      state.loading = false;
      state.formData = { ...state.formData, ...action.payload };
    },
    resetState: (state) => {
      return initialState;  // Mengatur ulang semua state ke nilai awal
    },
    setActiveTab: (state, action) => {
      console.log('🔄 Redux setActiveTab called with:', action.payload, '(mst07brand)');
      state.activeTab = action.payload;
    },
    setDataList: (state, action) => {
      state.dataList = action.payload;
    },
    setTotalData: (state, action) => {
      state.totalData = action.payload;
    },
    clearModuleState: (state) => {
      console.log('🧹 Clearing mst07brand module state for fresh start');
      // Reset to List tab (index 0)
      state.activeTab = 0;
      // Clear data for fresh load
      state.dataList = [];
      state.totalData = 0;
      // Clear any selected row
      state.selectedRow = null;
      // Clear form data
      state.formData = initialState.formData;
      // Reset loading states
      state.loading = false;
      state.loadingMessage = '';
      state.error = null;
    }
  },
});

export const {
  setSelectedRow,
  setFormData,
  clearFormData,
  setLoading,
  setErrorMsg,
  setLoadingMessage,
  fetchDetailSuccess,
  fetchDetailFailure,
  fetchDetailError,
  resetState,
  updateFormData,
  setActiveTab,
  setDataList,
  setTotalData,
  clearModuleState
} = mst07brandSlice.actions;

export default mst07brandSlice.reducer;
